import React, { useEffect, useState } from 'react'
import Sidebar from '../Sidebar'
import { Link, useNavigate } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
// import { deleteProduct } from '../../Redux/ProductSlice';
import axios from 'axios';  


function ProductHome(props) {
    let navigate = useNavigate();
  
    const admin = sessionStorage.getItem('admin');
  
    useEffect(()=>{
      
      if(!admin)
        { 
          navigate('/login');
        }
    },[])
    // const dispatch = useDispatch();
    // const products = useSelector((state) => state.products);
    // const handleDelete = (id) => {
    //     dispatch(deleteProduct({ id: id }));
    // }     

    const handleDelete =async(_id)=>{ 
        try{
          const res = await axios.delete(`https://sportsblendserver.netlify.app/.netlify/functions/api/deleteProduct/${_id}`); 
        // console.log(res);
        window.location.reload();
        }
        catch(err){
          console.log("Error in handleDelete: ",err);
        }
      }
    const [products, setProducts] = useState([]);
    useEffect(() => {
        axios.get("https://sportsblendserver.netlify.app/.netlify/functions/api/displayProduct")
            .then((res) => {
                // console.log("\nTHe photos or data are ", res.data, "\n");
                setProducts(res.data);
 
            })
            .catch((err) => console.log(err));
    }, [])

    return (
        <div className='d-flex'>
            <Sidebar />

            <div className='container'>
                <Link to='/productCreate' className='btn btn-success my-3'>Create+</Link>
                <div className='table-responsive'>
                    <table className='table table-sm justify-content-center'>

                        <thead >
                            <tr>
                                <th className="text-center">ID</th>
                                <th className="text-center">Name</th>
                                <th className="text-center">Price</th>

                                <th className="text-center">Description</th>
                                <th className="text-center">Image</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                products.map((product, index) =>
                                    <tr key={index}>
                                        <td className="text-center">{index+1}</td>
                                        <td className="text-center">{product.name}</td>
                                        <td className="text-center">{product.price}</td>
                                        <td className="text-center">{product.details}</td>
                                        <td className="text-center">{product.category}</td>
                                        <td className="text-center">
                                            {product.photo[0] && (
                                                <div className="d-flex justify-content-center">
                                                    <img style={{border:"2px green solid", marginBottom:"5px"}}
                                                        src={`https://sportsblendserver.netlify.app/.netlify/images?url=/images/${product.photo[0]}`}
                                                        alt={`product ${product.id}`}
                                                        className="img-thumbnail" 
                                                    />
                                                    </div>
                                                     
                                            )}
                                            {product.photo[1] && (
                                                <div className="d-flex justify-content-center">
                                                    <img style={{border:"2px green solid", marginBottom:"5px"}}
                                                        src={`https://sportsblendserver.netlify.app/.netlify/images?url=/images/${product.photo[1]}`}
                                                        alt={`product ${product.id}`}
                                                        className="img-thumbnail" 
                                                    />
                                                    </div>
                                                     
                                            )}
                                        </td>


                                        <td className="text-center">
                                            <Link to={`/productUpdate/${product.id}`} className='btn btn-sm btn-primary'><FontAwesomeIcon icon={faEdit}></FontAwesomeIcon></Link>
                                            <button onClick={() => handleDelete(product._id)} className='btn btn-sm btn-danger ns-2'><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></button>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    )
}

export default ProductHome;
